<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :apiUrl="apiUrl"
      withoutDelete>

      <template #additionalButton>
        <button
          class="btn btn-sm btn-primary btn-icon-split"
          v-b-tooltip.hover
          :disabled="!selectedItem"
          title="Terima"
          @click="acceptItem">
          <span class="icon">
            <i class="fas fa-hands" />
          </span>
          <span class="text d-none d-lg-inline-block">Terima</span>
        </button>
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :search="search"
      :filter="scopedFilterData"
      @onSelectItem="selectedItem = $event"
      @onDblClicked="item => acceptItem(item)" />

    <b-modal id="modalAcc" hide-footer no-close-on-backdrop centered size="sm" title="Penerimaan Barang" header-class="bg-light text-primary py-1">
      <div class="text-center">
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Tanggal</label>
          <div class="col-sm-9">
            <b-form-datepicker v-model="formAcc.DateReceived" locale="id" size="sm" :max="new Date()" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Jumlah</label>
          <div class="col-sm-9">
            <!-- <b-form-spinbutton size="sm" v-model.number="formAcc.Quantity" min="1" :max="maxItem" /> -->
            <input class="form-control" :value="formAcc.Quantity" disabled />
          </div>
        </div>

        <button class="btn btn-primary btn-sm" @click="onSubmitAccept">Terima</button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.scopedFilterData.departmentId = this.userDepartmentId
  },
  data() {
    return {
      apiUrl: '/logistic-distribution',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'DateSent', label: 'Tanggal', formatter: value => this.$helper.formatDateTime(value) },
        { key: 'LogisticEntryTransaction', label: 'Barang', formatter: value => value.LogisticItem.Name },
        // { key: 'SourceDistribution', label: 'Asal Ruang', formatter: value => value.LogisticEntryTransaction.Department.Name },
        { key: 'Department', label: 'Ruang Tujuan', formatter: value => value.Name },
        { key: 'Quantity', label: 'Jumlah' },
        { key: 'QuantityLimit', label: 'Sisa' },
        { key: 'ReceiverUser', label: 'Penerima', formatter: value => {
          return value ? value.Employee.Name : ''
        }},
        { key: 'LogisticDistributionStatus', label: 'Status', formatter: value => {

          if (!value) {
            return
          }

          if (value.Restrict === 1) {
            return `<span class="badge badge-success">${value.Name}</span>`
          } else {
            return `<span class="badge badge-danger">${value.Name}</span>`
          }
        }}
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {},
      scopedDetailData: {},
      scopedFilterData: {
        departmentId: null
      },
      maxItem: null,
      targetDistributionId: null,
      formAcc: {
        LogisticDistributionStatusID: null,
        DateReceived: null,
        Quantity: null,
        LogisticItemID: null,
        DepartmentID: null
      }
    }
  },
  computed: {
    userDepartmentId () {
      return this.$store.getters['user/userDepartment'].ID
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    acceptItem (item) {
      item = (item.constructor === Object) ? item : this.selectedItem

      this.maxItem = item.QuantityLimit
      this.targetDistributionId = item.ID

      this.formAcc.Quantity = item.QuantityLimit
      this.formAcc.DateReceived = new Date()
      this.formAcc.DepartmentID = this.$store.state.user.userData.employee.DepartmentID,
      this.formAcc.LogisticItemID = item.LogisticEntryTransaction.LogisticItemID,
      this.formAcc.LogisticDistributionStatusID = 2

      this.$bvModal.show('modalAcc')
    },

    onSubmitAccept () {
      this.$axios.post(`/logistic-distribution/${this.targetDistributionId}`, this.formAcc).then(res => {
        this.onRefresh()

        this.$bvModal.hide('modalAcc')

        this.$bvToast.toast('Berhasil disimpan', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true
        })
      })
    }
  }
}
</script>
